import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateParkingServiceTags } from '../../api/parking-service.ts';
import { UpdateParkingServiceTagsRequest } from '../../api/requests/parking-service-request.ts';

export default function useUpdateParkingServiceTags(): UseMutationResult<
  Awaited<ReturnType<typeof updateParkingServiceTags>>,
  Error,
  UpdateParkingServiceTagsRequest
> {
  return useMutation({
    mutationFn: updateParkingServiceTags,
  });
}
